import { render, staticRenderFns } from "./ModalVerifyAge.vue?vue&type=template&id=cb84356a&"
import script from "./ModalVerifyAge.vue?vue&type=script&lang=js&"
export * from "./ModalVerifyAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports